module.exports = __webpack_public_path__ + "img/discord-join-now.fe8a5243.png";